import { Bell } from "lucide-react";
import { useNotifications } from "@/hooks/useNotifications";
import type { ChatHistory } from "@/types/chat";
import { Badge } from "@/components/ui/badge";

export function PersonaNotifications() {
  const { unreadChats } = useNotifications();

  if (unreadChats.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Bell className="h-4 w-4 text-muted-foreground" />
      <div className="flex gap-1">
        {unreadChats.map((chat: ChatHistory) => (
          <Badge
            key={chat.personaName}
            variant="notification"
            className="text-xs"
          >
            {chat.personaName} ({chat.unreadCount})
          </Badge>
        ))}
      </div>
    </div>
  );
}
